export default __webpack_public_path__ + "static/media/gyroX.39813534.svg";